module.exports = "- Don’t pass any children of type other than CardItem or CardSection to the Card component.\n"